import { useDeviceType } from '@cian/ui-kit';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { makeSearch } from 'shared/map-search/actions/search';
import { IFiltersUpdatedEventDetail } from 'shared/map-search/types/microfrontends';
import { TThunkDispatch } from 'shared/map-search/types/redux';

/**
 * Подписывается на событие из микрофронта на применение фильтров
 */
export const useFiltersUpdatedEvent = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const deviceType = useDeviceType();

  const isAwaitingGeoUpdate = useRef<boolean>(false);

  useEffect(() => {
    const onFiltersUpdated = ({ detail }: CustomEvent<IFiltersUpdatedEventDetail>) => {
      dispatch(makeSearch({ isAwaitingGeoUpdate, deviceType, detail }));
    };

    addEventListener('filters:updated', onFiltersUpdated);

    return () => {
      removeEventListener('filters:updated', onFiltersUpdated);
    };
  }, [dispatch]);
};
